// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import onePageCheckoutAddressSectionSharedStyles from "@bg/App/SharedStyles/OnePageCheckout/OnePageCheckoutAddressSectionSharedStyles";
import { onePageCheckoutBillingAddressStyles } from "@bg/App/Widgets/OnePageCheckout/OnePageCheckoutBillingAddress";
import { css } from "styled-components";

onePageCheckoutBillingAddressStyles.container = {
    ...onePageCheckoutAddressSectionSharedStyles.container,
};

onePageCheckoutBillingAddressStyles.titleContainer = {
    ...onePageCheckoutAddressSectionSharedStyles.titleContainer,
};

onePageCheckoutBillingAddressStyles.heading = {
    ...onePageCheckoutAddressSectionSharedStyles.heading,
};

onePageCheckoutBillingAddressStyles.editSavedAddressesLink = {
    typographyProps: {
        size: 15,
        weight: 500,
        lineHeight: "23px",
    },
    css: css`
        line-height: 23px;
    `,
};

onePageCheckoutBillingAddressStyles.billingAddressForm = {
    ...onePageCheckoutAddressSectionSharedStyles.addressForm,
};

onePageCheckoutBillingAddressStyles.addressInfoDisplay = {
    ...onePageCheckoutAddressSectionSharedStyles.addressInfoDisplay,
};

onePageCheckoutBillingAddressStyles.billToContainer = {
    css: css`
        margin-top: 2px;
    `,
};

onePageCheckoutBillingAddressStyles.actionContainer = {
    ...onePageCheckoutAddressSectionSharedStyles.actionContainer,
};

onePageCheckoutBillingAddressStyles.saveAddressButton = {
    ...onePageCheckoutAddressSectionSharedStyles.saveAddressButton,
};

onePageCheckoutBillingAddressStyles.cancelEditButton = {
    ...onePageCheckoutAddressSectionSharedStyles.cancelEditButton,
};

onePageCheckoutBillingAddressStyles.editAddressLink = {
    ...onePageCheckoutAddressSectionSharedStyles.editAddressLink,
};
